module.exports = __webpack_public_path__ + "static/media/partner-fit.a3916e57.svg";